import React from 'react';
import classNames from 'classnames';
import { ProfileField } from '../../../types/profile';
import { socialTypeIcons } from '../../../utils/iconUtils';
import { capitalizeFirstLetter } from '../../../utils/stringUtils';

interface SocialProps {
  field: ProfileField;
  handleClick?: (active: boolean, field: ProfileField) => void;
  active?: boolean;
  mandatory?: boolean;
}
export default function Social({
  field,
  handleClick = () => {},
  active = false,
  mandatory = false,
}: SocialProps): JSX.Element {
  return (
    <div
      key={field.id!}
      onClick={() => handleClick(active, field)}
      className={classNames(
        'flex w-full cursor-pointer items-center justify-between rounded-lg border bg-secondary px-3 py-2',
        {
          'bg-secondary-50': active,
        },
      )}>
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center rounded-lg bg-secondary-200 p-1 text-primary">
          {socialTypeIcons[field.social?.socialType as keyof typeof socialTypeIcons]}
        </div>
        <div className="text-sm font-medium text-primary-900">
          <p>
            {capitalizeFirstLetter(field.social?.socialType ?? '')}
            {mandatory && '*'}
          </p>
          <p className="text-sm font-normal text-gray-700">{field.social?.link}</p>
        </div>
      </div>
      <div className="flex h-8 w-8 items-center justify-center">
        <input
          type="checkbox"
          className="form-checkbox h-5 w-5 cursor-pointer rounded-lg border-secondary-50 bg-secondary-200 text-primary-300 accent-primary-900 focus:ring-0 focus:ring-transparent"
          checked={active}
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    </div>
  );
}
